import Airtable from "airtable"

const baseURL = "appA2VRS2rpjEkdfC"
export const base = new Airtable({
  apiKey:
    "patnGrVQyqLmTN6FV.c5e419a3c6b821fda5a007e557d85058464faaa01ecbf1e3c742ae0c669e4a5e",
}).base(baseURL)
